module.exports = __webpack_public_path__ + "static/img/screen-control-open.d0b06ccd.svg";